import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

// Types
import type { GiveawayResultsResponse } from '@/components/pages/giveaway-picker/Types/drawTypes';

const useCheckResults = (
    url: string,
    options?: SWRConfiguration<GiveawayResultsResponse, ErrorCustom>
) => {
    const { data, error, isLoading } = useSWR<GiveawayResultsResponse, ErrorCustom>(
        url || null,
        async (url) => {
            const startTime = Date.now();
            while (Date.now() - startTime < 30000) {
                const res = await get(url);
                if (res.data?.result_signature) {
                    return res.data;
                }
                await new Promise((resolve) => setTimeout(resolve, 5000));
            }
            return { message: 'check-email' };
        },
        {
            shouldRetryOnError: true,
            ...options
        }
    );
    return {
        giveawayResultsData: data,
        giveawayResultsError: error,
        isLoading
    };
};

export default useCheckResults;
